import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_py5eck82gd: FaireBrandEntity = {
  token: "b_py5eck82gd",
  type: "brand",
  name: "Everlasting Candle Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/eafd8984e361af98216b52aaa3f66bc6c466c3bd60a9205f947726d751be48d0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d01e96f599bac8be351ea3fcba5678b9821e1abd6b167aef6019249ba9e54f07.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/eafd8984e361af98216b52aaa3f66bc6c466c3bd60a9205f947726d751be48d0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d01e96f599bac8be351ea3fcba5678b9821e1abd6b167aef6019249ba9e54f07.jpeg",
  location: "Vancouver, BC, CAN",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 108,
  isTopShop: true,
  isInsider: true,
  description:
    "THE CANDLE REIMAGINED.\n\nEverlasting Candle Co. is a proudly Canadian brand redefining candlelight through sustainable, elevated design. Our patented signature product is a clean burning, reusable steel candlestick that never melts, powered by our exclusive Pristine Oil®. The result is a smoke free, scent free candlelight experience that blends timeless beauty with modern functionality and has no true comparison on the market.\n\nDesigned to be reused again and again, Everlasting Candles offer customers a longer lasting alternative to traditional wax candles while creating built in repeat purchases through oil refills. Each piece is thoughtfully made to feel luxurious, giftable, and effortless to style in any home.\n\nOur commitment to making a positive impact goes beyond crafting beautiful and sustainable candles. All Everlasting Candles are handmade in Vancouver, Canada through our long standing partnership with the Disability Association of Canada. Together, we provide fair, meaningful employment opportunities for individuals with disabilities and support a more inclusive future. Every order your store places helps further this mission.\n\nWe are proud to partner with retailers who value quality, sustainability, and thoughtful design. Offer your customers a candle experience unlike anything else on the market and a home décor piece they will continue to enjoy long after the flame is lit.\n\nWe look forward to partnering with you.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:46.570Z",
    importedBy: "entity-db-cli",
  },
};
